import request from '../utils/request'

export const listAnnotationProjects = () => request({
  url: '/api/pic/listAnnotationProjects',
  headers: {
    'Token-Circus': window.localStorage.getItem('Token-Circus'),
    'Unique-Ident': window.localStorage.getItem('umtId')
  },
})

export const selectAnnotationProject = (projectId) => request({
  url: '/api/pic/selectAnnotationProject',
  method: 'post',
  params: { projectId },
  headers: {
    'Token-Circus': window.localStorage.getItem('Token-Circus'),
    'Unique-Ident': window.localStorage.getItem('umtId')
  },
})

export const getAnnotationBatch = (project) => request({
  url: '/api/pic/getAnnotationBatch',
  params: project ? { project } : {},
  headers: {
    'Token-Circus': window.localStorage.getItem('Token-Circus'),
    'Unique-Ident': window.localStorage.getItem('umtId')
  },
})

export const submitAnnotationBatch = () => request({
  url: '/api/pic/submitAnnotationBatch',
  method: 'post',
  headers: {
    'Token-Circus': window.localStorage.getItem('Token-Circus'),
    'Unique-Ident': window.localStorage.getItem('umtId')
  },
})

export const getAnnotationProgress = () => request({
  url: '/api/pic/getAnnotationProgress',
  headers: {
    'Token-Circus': window.localStorage.getItem('Token-Circus'),
    'Unique-Ident': window.localStorage.getItem('umtId')
  },
})

/** 指定项目的全站标注统计（首页看板） */
export const getProjectSiteProgress = (projectId) => request({
  url: '/api/pic/getProjectSiteProgress',
  params: { projectId },
})
